import script from "./ProductCardRecommendation.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductCardRecommendation.vue?vue&type=script&setup=true&lang=ts"

import "./ProductCardRecommendation.vue?vue&type=style&index=0&id=f4a79308&lang=scss"

const __exports__ = script;

export default __exports__